<template>
    <div class="wrapper ">
        <Sidebar />
        <div class="main-panel" id="main-panel">
            <Header />
            <div class="panel-header panel-header-sm">
                <canvas id="bigDashboardChart"></canvas>
            </div>
            <div class="content">
                <Loading v-if="loading === true"/>
                <div id="row">
                    <div class="card">
                        <div class="card-body">
                            <h5 v-if="isSuperAdmin === true" >Pick an Institute</h5>

                            <label class="sr-only" for="institute-select">Pick an Institute</label>
                            <select class="form-control custom-dropdown mb-5" id="institute-select" v-model="selectedMuseum" @change="getMuseumListings()">
                                <option disabled value="">Institutes</option>
                                <option v-if="isSuperAdmin === true" value="publicArt">Public Art</option>
                                <option v-for="museum in museums" :key="museum.id" :value="museum">{{museum.name}}</option>
                            </select>

                            <h5 class="card-title">Approved Artworks</h5>
                            <v-client-table :data="tableData" :columns="columns" :options="options">
                                <div slot="listingVerified" slot-scope="{row}" style="text-align: center;">
                                    <img style="width: 25px;" v-if="row.listingVerified" src="../assets/verifiedIcon.png" alt="verified" />
                                </div>
                                <div slot="listingName" slot-scope="{row}">
                                    {{ row.listingName }}
                                </div>
                                <div slot="listingArtist" slot-scope="{row}">
                                    {{  row.listingArtist}}
                                </div>
                                <div slot="listingThumbnail" slot-scope="{row}" style="text-align: center;">
                                    <img style="max-width: 4em;" :src="row.listingThumbnail" :alt="row.listingName" />
                                </div>
                                <div slot="listingArchived" slot-scope="{row}">
                                    
          <button v-if="isSuperAdmin === true" @click="statusChangeListing(row.listingID)" class="transparent-button"><i class="edit-button fa fa-edit"></i>{{ row.listingArchived===0 ? "Unarchived" : "Archived" }}</button>
         
                                </div>
                                <div slot="actions" slot-scope="{row}">
                                    
                                    <button @click="editListing(row.listingID)" class="transparent-button ml-3"><i class="edit-button fa fa-edit"></i> Edit/Verify</button>
                                    <button v-if="isSuperAdmin === true" @click="deleteListing(row.listingID)" class="transparent-button"><i class="delete-button fa fa-trash"></i> Delete</button>
                                </div>
                            </v-client-table>
                        </div>
                    </div>
                </div>
                <div class="tabs">
                    <a style="font-weight: 500;" @click="activeTab = 1" :class="[ activeTab === 1 ? 'active' : '' ]">Catalog New Artwork</a>
                    <a v-if="isSuperAdmin === true" style="font-weight: 500;" @click="activeTab = 2" :class="[ activeTab === 2 ? 'active' : '' ]">Pending Approval ({{ pendingListingsCount }})</a>
                </div>
                <div class="row">
                    <div class="col-lg-12">
                        <div v-if="activeTab === 1">
                            <div class="card card-chart">
                                <div class="card-header">
                                    <h5 class="card-title">Catalog Artwork</h5>
                                    <h5 class="card-category">* Mandatory Fields</h5>
                                </div>
                                <div class="card-body">
                                    <div class="form-group">
                                        <div class="row mb-3">
                                            <div class="col">
                                                <label class="sr-only" for="artworkTitle">Artwork Title</label>
                                                <input v-model="listing.name" id="artworkTitle" type="text" placeholder="* Artwork Title" class="form-control"/>
                                            </div>
                                            <div class="col">
                                                <label class="sr-only" for="artworkEra">Era</label>
                                                <select class="form-control custom-dropdown" id="artworkEra" v-model="listing.era">
                                                    <option disabled selected value="">Era</option>
                                                    <option v-for="era in eras" :key="era.id" :value="era">{{era.name}}</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="row mb-3">
                                            <div class="col">
                                                <label class="sr-only" for="artworkYear">Year</label>
                                                <input v-model="listing.year" id="artworkYear" type="text" placeholder="* Year" class="form-control" maxlength="4"/>
                                            </div>
                                            <div class="col">
                                                <label class="sr-only" for="artworkObjectNumber">Object Number</label>
                                                <input v-model="listing.objectNumber" id="artworkObjectNumber" type="text" placeholder="Object Number" class="form-control"/>
                                            </div>
                                        </div>
                                        <div class="row mb-1">
                                             <div class="col my-auto ml-3">
                                                <div class="form-group my-auto">
                                                    <label class="form-check-label"><input type="checkbox" v-model="listing.onDisplay"> On Display</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row mb-1">
                                             <div class="col my-auto ml-3">
                                                <div class="form-group my-auto">
                                                    <label class="form-check-label"><input type="checkbox" v-model="listing.circa"> Circa</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row mb-3">
                                             <div class="col my-auto ml-3">
                                                <div class="form-group my-auto">
                                                    <label class="form-check-label"><input type="checkbox" v-model="listing.BC"> BC</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row mb-3">
                                            <div v-if="isSuperAdmin === true" class="col">
                                                <label class="sr-only" for="artworkInstitute">Institute</label>
                                                <select class="form-control custom-dropdown mb-5" id="artworkInstitute" v-model="listing.museum">
                                                    <option disabled value="">Institute</option>
                                                    <option v-for="museum in museums" :key="museum.id" :value="museum">{{museum.name}}</option>
                                                </select>
                                            </div>
                                            <div class="col">
                                                <label class="sr-only" for="artworkMedium">Medium</label>
                                                <select class="form-control custom-dropdown" id="artworkMedium" v-model="listing.medium">
                                                    <option disabled selected value="">* Medium</option>
                                                    <option v-for="medium in mediums" :key="medium.id" :value="medium">{{medium.name}}</option>
                                                </select>
                                            </div>
                                            <div class="col">
                                                <label class="sr-only" for="artworkArtist">Artist</label>
                                                <select class="form-control custom-dropdown" id="artworkArtist" v-model="listing.artist">
                                                    <option disabled selected value="">* Artist</option>
                                                    <option v-for="artist in artists" :key="artist.id" :value="artist.id">{{artist.name}}</option>
                                                </select>
                                                <button type="button" class="btn btn-primary btn-neutral btn-museo-link pull-right" @click="addNewArtist">Artist Not Listed</button>
                                            </div>
                                        </div>

                                        <Alert v-if="errorMessage.length > 0" :message="errorMessage" :error="true"/>
                                        <Alert v-if="successMessage.length > 0" :message="successMessage" :error="false"/>
                                        <button class="btn btn-primary mt-5" @click="addListing(listing)">Catalog</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <div class="card">
                                <div class="card-body">
                                    <Alert v-if="errorMessage.length > 0" :message="errorMessage" :error="true"/>
                                    <Alert v-if="successMessage.length > 0" :message="successMessage" :error="false"/>
                                    <v-client-table :data="pendingData" :columns="pendingColumns" :options="pendingOptions">
                                        <div slot="pendingThumbnail" slot-scope="{row}" style="text-align: center;">
                                            <img style="max-width: 9em;" :src="row.pendingThumbnail" :alt="row.pendingName"/>
                                        </div>
                                        
                                        <div slot="pendingActions" slot-scope="{row}">
                                            <button @click="approvePending(row)" class="transparent-button ml-3"><i class="edit-button fa fa-check"></i> Approve</button>
                                            <button @click="rejectPending(row)" class="transparent-button ml-3"><i class="delete-button fa fa-times"></i> Reject</button>
                                        </div>
                                    </v-client-table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <Footer />
        </div>

        <NewArtistModal @artistCreated="artistCreated" />

    </div>
</template>

<script>
    import Mediums from '../controllers/medium.controller';
    import Eras from '../controllers/eras.controller';
    import Listings from '../controllers/listing.controller';
    import Museums from '../controllers/museum.controller';
    import Artists from '../controllers/artist.controller';
    import isSuperAdmin from '../services/jwt/isSuperAdmin';
    import getUID from '../services/firebase/getUID';
   // import resolveArtStatusArchiveUnarchive from '@/helpers/constant.js';
    export default {
        name: 'Listings',
        data: function() {
            return {
//resolveArtStatusArchiveUnarchive,
                activeTab: !this.$route.params.review ? 1 : 2,
                listings: [],
                museums: [],
                mediums: [],
                eras: [],
                artists: [],
                selectedMuseum: '',
                listing: {
                    name: '',
                    era: '',
                    objectNumber: null,
                    year: '',
                    artist: '',
                    onDisplay: true,
                    circa: false,
                    BC: false,
                    medium: '',
                    museum: ''
                },
                columns: ['listingVerified', 'listingName', 'listingMedium', 'listingEra', 'listingObjectNumber', 'listingYear', 'listingArtist', 'listingThumbnail', 'listingAddress', 'listingCreatedBy', 'listingCreatedAt','listingArchived', 'actions'],
                tableData: [],
                options: {
                    perPage: 10,
                    pagination: { chunk: 10, dropdown: false },
                    filterable: true,
                    headings: {
                        listingVerified: 'Verified',
                        listingName: 'Title',
                        listingMedium: 'Medium',
                        listingEra: 'Era',
                        listingObjectNumber: 'Object Number',
                        listingYear: 'Year',
                        listingArtist: 'Artist',
                        listingThumbnail: 'Thumbnail',
                        listingAddress: 'Address',
                        listingCreatedBy: 'Created By (Handle)',
                        listingCreatedAt: 'Created At',
                        listingArchived: 'Archived'
                    },
                    sortIcon: {
                        base : 'fa',
                        is: 'fa-sort',
                        up: 'fa-sort-asc',
                        down: 'fa-sort-desc'
                    }
                },
                pendingColumns: ['pendingName', 'pendingMedium', 'pendingEra', 'pendingYear', 'pendingArtist', 'pendingMuseum', 'pendingObjectNumber' ,'pendingThumbnail', 'pendingCreatedBy', 'pendingActions'],
                pendingData: [],
                pendingOptions: {
                    perPage: 10,
                    pagination: { chunk: 10, dropdown: false },
                    filterable: false,
                    headings: {
                        pendingName: 'Title',
                        pendingMedium: 'Medium',
                        pendingEra: 'Era',
                        pendingYear: 'Year',
                        pendingArtist: 'Artist',
                        pendingMuseum: 'Institute',
                        pendingThumbnail: 'Thumbnail',
                        pendingObjectNumber: 'Object Number',
                        pendingCreatedBy: 'Submitted By',
                        pendingActions: 'Actions'
                    },
                    sortIcon: {
                        base : 'fa',
                        is: 'fa-sort',
                        up: 'fa-sort-asc',
                        down: 'fa-sort-desc'
                    }
                },
                loading: false,
                errorMessage: '',
                successMessage: '',
                isSuperAdmin: isSuperAdmin(localStorage.getItem('superAdmin')),
                pendingListingsCount: 0,
                pendingListings: [],
            }
        },
        beforeMount: async function() {
            
            this.loading = true;
            // Fetch all the information that we need for the view
            this.mediums = await Mediums.getAll();
            this.eras = await Eras.getAll();
            this.artists = await Artists.getAll();
            
            this.pendingListings = [];
            if (this.isSuperAdmin === true) {
                this.pendingListingsCount = await Listings.getUnapprovedCount();
                this.pendingListings = await Listings.getUnapproved();
                this.pendingListings.forEach(listing => {
                    this.pendingData.push({
                        id: listing.id,
                        pendingName: !listing.name ? "" : listing.name,
                        pendingMedium: listing.medium == null ? "N/A" : listing.medium.name,
                        pendingEra: listing.era == null ? "N/A" : listing.era.name,
                        pendingYear: listing.year == null ? "N/A": listing.year,
                        pendingArtist: !listing.artist ? "N/A" : listing.artist.name,
                        pendingArtistID: !listing.artist ? null : listing.artist.id,
                        pendingMuseum: listing.street_art==1 ? null : listing.museum==null ? null:listing.museum.name,
                        pendingMuseumID: listing.street_art==1 ? null : listing.museum==null ? null:listing.museum.id,
                        pendingThumbnail: listing.image,
                        pendingObjectNumber: listing.object_number,
                        pendingCreatedBy: listing.createdBy.display_name
                        });
                        })
                        
                        this.museums = await Museums.getAll();
                        } else {
                            let uid = await getUID(localStorage.getItem('superAdmin'));
                            this.museums = await Museums.getCuratorMuseums(uid);
                            this.selectedMuseum = this.museums[0];
                            await this.getMuseumListings();
                            
                            // A curator can see only the pending museums of their list
                            for (let museum of this.museums) {
                                this.pendingListingsCount += await Listings.getUnapprovedCount(museum.id);
                                this.pendingListings = await Listings.getUnapproved(museum.id);
                                }
                                
                                this.pendingListings.forEach(listing => {
                                    this.pendingData.push({
                                        id: listing.id,
                                        pendingName: listing.name,
                                        pendingMedium: listing.medium == null ? "N/A" : listing.medium.name,
                                        pendingEra: listing.era == null ? "N/A" : listing.era.name,
                                        pendingYear: listing.year == null ? "N/A": listing.year,
                                        pendingArtist: listing.artist ? "N/A" : listing.artist.name,
                                        pendingMuseum: listing.street_art ? null : listing.museum.name,
                                        pendingThumbnail: listing.image,
                                        pendingObjectNumber: listing.object_number
                    });
                })
                
            }
            
            
            this.loading = false;
        },

        methods: {

            addNewArtist() {
                this.$modal.show('new-artist-modal')
            },
            
            async artistCreated(event) {
                this.listing.artist = event.artistID == null ? '' : event.artistID;
                this.artists = await Artists.getAll();
            },

            async addListing(listing) {
                // Reset the alert messages
                this.successMessage = '';
                this.errorMessage = '';

                if (!listing.name || !listing.year || !listing.medium || !listing.artist) {
                    this.errorMessage = 'Fill all mandatory fields';
                    return;
                }

                if (isNaN(listing.year)) {
                    this.errorMessage = 'Year field must be a number';
                    return;
                } else {
                    listing.year = parseInt(listing.year, 10);
                }

                this.loading = true;

                if (this.isSuperAdmin === false) {
                    listing.museum = this.selectedMuseum;
                }

                let cataloged = await Listings.catalogNew(listing);

                if (cataloged === true) {
                    this.resetForm();
                    this.successMessage = 'Artwork cataloged successfully';
                    // Refresh the data
                    await this.getMuseumListings();
                } else if (cataloged.error) {
                    this.errorMessage = cataloged.error;
                } else {
                    this.errorMessage = 'Something went wrong cataloging your artwork';
                }

                this.loading = false;
            },

            async getMuseumListings() {
                this.loading = true;

                // Reset the listings array 
                this.tableData = [];

                if (this.selectedMuseum === "publicArt") {
                    // Fetch the public art
                    this.listings = await Listings.getPublicArt();
                } else {
                    // Fetch the listings for the newly selected museum
                    this.listings = await Listings.getByMuseumID(this.selectedMuseum.id);
                }

                if (this.listings.length > 0) {
                    this.listings.forEach(listing => {
                        if (listing.approved === 1) {
                            let createdAt = new Date(listing.created_at);
                            let day = createdAt.getDate() < 10 ? "0" + createdAt.getDate() : createdAt.getDate();
                            let month = (createdAt.getMonth() + 1) < 10 ? "0" + (createdAt.getMonth() + 1) : (createdAt.getMonth() + 1);
                            createdAt = month + "/" + day + "/" + createdAt.getFullYear();

                            let address = "N/A";
                            if (listing.address) {
                                if (listing.address.address_1) {
                                    address = listing.address.address_1;
                                }
                                if (listing.address.city) {
                                    address = address + " " + listing.address.city;
                                }
                                if (listing.address.state) {
                                    address = address + " " + listing.address.state;
                                }
                                if (listing.address.postal_code) {
                                    address = address + " " + listing.address.postal_code;
                                }
                                if (listing.address.country) {
                                    address = address + " " + listing.address.country;
                                }
                            }
                            this.tableData.push({
                                listingArchived: listing.is_archived,
                                listingID: listing.id,
                                listingName: !listing.name ? "Unknown" : listing.name,
                                listingMedium: !this.medium ? "N/A" : this.medium.name,
                                listingEra: !this.medium ? "N/A" : this.era.name,
                                listingObjectNumber: listing.object_number,
                                listingYear: listing.year,
                                listingThumbnail: listing.image,
                                listingArtist: !listing.artist ? "N/A" : listing.artist.name,
                                listingVerified: listing.verified,
                                listingCreatedBy: !listing.createdBy ? "N/A" : "@" + listing.createdBy.display_name,
                                listingCreatedAt: createdAt,
                                listingAddress: address
                            });
                        }
                    });
                }

                this.loading = false;
            },

            resetForm() {
                this.errorMessage = '';
                this.listing = {};
            },

            editListing(listingID) {
                this.$router.push({name: 'EditListing', params: { listingID: listingID }});
            },
            async statusChangeListing(listingID) {
                if (window.confirm("Are you sure you want to change status of this artwork?")) {
                    let listedChanged = await Listings.status(listingID);
                    if (listedChanged === true) {
                        await this.getMuseumListings();
                    } else {
                        this.errorMessage = 'Something went wrong with status changing the listing';
                    }
                }
            },
            async deleteListing(listingID) {
                if (window.confirm("Are you sure you want to delete this artwork? This action cannot be undone.")) {
                    let listingDeleted = await Listings.delete(listingID);

                    if (listingDeleted === true) {
                        // Artwork deleted successfully, refresh the data
                        await this.getMuseumListings();
                    } else {
                        this.errorMessage = 'Something went wrong with deleting the listing';
                    }
                }
            },

            async approvePending(listing) {

                this.loading = true;
                this.successMessage = '';
                this.errorMessage = '';
                let approved = await Listings.approve(listing.id);

                if (approved === false) {
                    this.errorMessage = "Something went wrong while approving the artwork";
                } else if (approved.error) {
                    this.errorMessage = approved.error;
                } else {
                    if (listing.pendingArtistID) {
                        let approvedArtist = await Artists.approve(listing.pendingArtistID);
                        if (approvedArtist.error) {

                            await Listings.unapprove(listing.id);
                            this.errorMessage = approvedArtist.error;

                        } else if (approvedArtist === false) {

                            await Listings.unapprove(listing.id);
                            this.errorMessage = "Something went wrong while approving the artwork";

                        } else if (listing.pendingMuseumID) {

                            let approvedArtist = await Museums.approve(listing.pendingMuseumID);
                            if (approvedArtist.error) {

                                await Listings.unapprove(listing.id);
                                this.errorMessage = approvedArtist.error;

                            } else if (approvedArtist === false) {

                                await Listings.unapprove(listing.id);
                                this.errorMessage = "Something went wrong while approving the artwork";

                            }
                        }
                    }

                    // Refresh Data if all went well
                    if (!this.errorMessage) {
                        await this.getListings();
                        this.successMessage = "Artwork approved!";
                    }
                }

                this.loading = false;
            },

            async rejectPending(listing) {
                if (window.confirm("Are you sure you want to reject this artwork? This action cannot be undone.")) {
                    this.loading = true;
                    this.successMessage = '';
                    this.errorMessage = '';

                    // Upon rejection the listing will be deleted
                    let deleted = await Listings.delete(listing.id);

                    if (deleted === false) {
                        this.errorMessage = "Something went wrong while rejecting this artwork";
                    } else if (deleted.error) {
                        this.errorMessage = deleted.error;
                    } else {
                        // Refresh Data
                        await this.getListings();
                        this.successMessage = "Artwork rejected!";
                    }

                    this.loading = false;
                }
            },

            async getListings() {
                if (this.isSuperAdmin === true) {
                    this.pendingListings = await Listings.getUnapproved();
                    this.pendingListingsCount = await Listings.getUnapprovedCount();
                } else {
                    this.pendingListings = await Listings.getUnapproved(this.selectedMuseum.id);
                    this.pendingListingsCount = await Listings.getUnapprovedCount(this.selectedMuseum.id);
                }

                this.pendingData = [];
                this.pendingListings.forEach(listing => {

                    let data = {
                        id: listing.id,
                        pendingName: listing.name,
                        pendingMedium: !listing.medium ? "N/A" : listing.medium.name,
                        pendingEra: !listing.era ? "N/A" : listing.era.name,
                        pendingYear: !listing.year ? "N/A": listing.year,
                        pendingArtist: !listing.artist ? "N/A" : listing.artist.name,
                        pendingThumbnail: listing.image,
                        pendingObjectNumber: listing.object_number
                    };

                    if (this.isSuperAdmin === true) {
                        data.pendingArtistID = !listing.artist ? null : listing.artist.id;
                        data.pendingMuseum = listing.street_art ? null : listing.museum.name;
                        data.pendingMuseumID = listing.street_art ? null : listing.museum.id;
                        data.pendingCreatedBy = listing.createdBy.display_name;
                    }

                    this.pendingData.push(data);

                });
            }
        }
    }
</script>